import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Button, Modal, Row, Col, Form } from "react-bootstrap";
import { MdRemoveRedEye } from "react-icons/md";

import axios from "axios";
import DataTable from "react-data-table-component";
import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import { Table } from 'react-bootstrap';
import { BsPatchCheckFill } from "react-icons/bs";
import AppDataGrid from '../../components/common/AppDataGrid';

const Approvals = () => {
    const [Roles, setRoles] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");
    const [students, setStudents] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const [isLoading, setIsLoading] = useState(true);
    const userData = sessionStorage.getItem('user');
    const [fees, setFees] = useState([]);
    const userObj = userData ? JSON.parse(userData) : {};
    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "School Admin",];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());
    const [form, setForm] = useState({
        student_id: "",
        student_first_name: "",
        student_last_name: "",
        dob: "",
        date_of_join: "",
        date_of_exit: "",
        image_id: "",
        class_id: "",
        class_name: "",
        section_id: "",
        section_name: "",
        roll_no: "",
        student_class_teacher_id: 0,
        student_class_teacher_name: "",
        gender: "",
        roll_no: "",
        passport_size_photo: "",
        academic_year_id: 0,
        academic_year_name: "",
        admission_number: "",
        class_last_studied: "",
        class_last_studied_name: "",
        class_name: "",
        previous_school_name: "",
        admission_to: "",
        class_name: "",
        school_id: 0,
        date_of_admission: "",
        which_school_student_has_gone: "",
        Total_Fee: "",
        Total_Due: "",
        grand_total: "",
        exit_type: "",
        document: "",
        exit_reason: "",
        exit_status: "",
    })
    useEffect(() => {
        setIsLoading(true);
        fetchStudents().finally(() => setIsLoading(false));
    }, []);
    const fetchStudents = async () => {
        try {
            const response = await axios.post(baseUrl + "/students/", {
                action: "READ", school_id: userObj.school_id
            });
            setStudents(response.data);
        } catch (error) {
            console.error("Error fetching students:", error);
        }
    };

    useEffect(() => {

        setIsLoading(true);
        fetchexit().finally(() => setIsLoading(false));
    }, []);


    const fetchexit = async () => {
        try {
            const response = await axios.post(baseUrl + "/studentexit/", {
                action: "READ",
                school_id: userObj.school_id
            });
            setRoles(response.data);
        } catch (error) {
            console.error("Error fetching roles:", error);

        }
    };

    const updateExitStatus = async (status) => {
        try {
            setIsLoading(true);
            if (form.exit_status === "Pending" && (!form.comments || form.comments.trim() === "")) {
                toast.error("Comments are required when status is Pending.");
                setIsLoading(false);
                return;
            }

            const payload = {
                action: "UPDATE",
                student_id: form.student_id,
                school_id: userObj.school_id,
                exit_status: status === "Approved" ? "A" : "R"
            };

            if (form.exit_status === "Pending" || form.comments) {
                payload.comments = form.comments || "";
            }

            const response = await axios.post(baseUrl + "/updateexitstatus/", payload);

            if (response.data && response.data.length > 0) {
                const updatedRecord = response.data[0];
                toast.success(`Status updated`);
                setShowExitForm(false);
                fetchStudents();
                fetchexit();
            } else {
                toast.error("Failed to update status");
            }
        } catch (error) {
            console.error("Error updating exit status:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const formatDate1 = (datetime) => {
        if (!datetime) return "";
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    };
    const handleInputChange = (e) => {
        const { id, value, files } = e.target;

        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));

    };

    const columns = [

      
        {
            field: 'admission_number',
            headerName: "Admission Number",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'student_last_name',
            headerName: "Surname",
            flex: 1,
            renderCell: (params) => {
                const surName = params.value || " ";
                return (
                    <Tooltip title={surName}>
                        <span>{surName.length > 10 ? surName.substring(0, 12) + "..." : surName}</span>
                    </Tooltip>
                )
            },
            sortable: true,
        },
        {
            field: 'student_first_name',
            headerName: "First Name",
            renderCell: (params) => {
                const firstName = params.value || " ";
                return (
                    <Tooltip title={firstName}>
                        <span>{firstName.length > 15 ? firstName.substring(0, 15) + "..." : firstName}</span>
                    </Tooltip>
                )
            },
            flex: 1,
            sortable: true,
        },
        {
            field: 'roll_no',
            headerName: "Roll Number",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'date_of_join',
            headerName: "DOJ",
            renderCell: (params) => {
                const DOJ = formatDate1(params.value || "");
                return (
                    <Tooltip title={DOJ}>
                        <span>{DOJ}</span>
                    </Tooltip>
                )
            },
        },
        {
            field: 'class_name',
            headerName: "Class",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'section_name',
            headerName: "Section",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,

        },
        {
            field: 'student_class_teacher_name',
            headerName: "Class Teacher",
            flex: 1,
            renderCell: (params) => {
                const teacherName = params.value || " ";
                return (
                    <Tooltip title={teacherName}>
                        <span>
                            {teacherName.length > 15 ? teacherName.substring(0, 15) + "..." : teacherName}
                        </span>
                    </Tooltip>
                );
            },
            sortable: true,
        },
        {
            field: 'gender',
            headerName: "Gender",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        {
            field: 'exit_status',
            headerName: "Exit Status",
            flex: 1,
            renderCell: (params) => <Tooltip title={params.value}><span>{params.value}</span></Tooltip>,
            sortable: true,
        },
        ...(canSubmit ? [{
            field: 'actions',
            headerName: 'Actions',
            flex: 1,
            sortable: false,
            renderCell: (params) =>
                (filteredRecords || []).length > 0 ? (
                    <div className="tableActions">
                        <Tooltip title="View" arrow>
                            <span
                                className="commonActionIcons"
                                onClick={() => handleDeleteClick(params.row.student_id)}
                            >
                                <MdRemoveRedEye />
                            </span>
                        </Tooltip>
                    </div>
                ) : null,
        }] : [])

    ];
    const [studentFeeSchedule, setStudentFeeSchedule] = useState([]);
    const [feeDetail, setFeeDetail] = useState(null);
    const fetchStudentFeeSchedule = async (student_id) => {
        if (!student_id) return;
        try {
            const { data } = await axios.get(`${baseUrl}/main/getstudentfeedetail`, {
                params: {
                    _school_id: userObj.school_id,
                    _academic_year_id: userObj.academic_year_id,
                    _student_id: student_id,
                    user_id:userObj.userObj
                },
            });

            // Handle both shapes safely:
            const root = Array.isArray(data) ? data[0] : data;
            const detail = root?.getstudentfeedetail || root;

            setFeeDetail(detail || null);
            setStudentFeeSchedule(detail?.schedules || []);
        } catch (err) {
            console.error("Error fetching fee schedule:", err);
            setFeeDetail(null);
            setStudentFeeSchedule([]);
        }
    };
    const [showExitForm, setShowExitForm] = useState(false);

    const handleDeleteClick = async (student_id) => {
        try {
            // setTermSummary([]);
            const studentToEdit = (students || []).find(student => student.student_id === student_id);
            console.log(studentToEdit);

            setForm(studentToEdit);
            fetchStudentFeeSchedule(student_id);

            setShowExitForm(true);
        } catch (error) {
            console.error("Failed to fetch student details", error);
            alert("Error fetching student data");
        }
    };


    const searchableColumns = [
        (row) => row.student_id,
        (row) => row.admission_number,
        (row) => row.student_last_name,
        (row) => row.student_first_name,
        (row) => row.roll_no,
        (row) => row.date_of_join,
        (row) => row.class_name,
        (row) => row.section_name,
        (row) => row.student_class_teacher_name,
        (row) => row.gender,
        (row) => row.status,
        (row) => row.exit_status






    ];

    const filteredRecords = (Roles || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );



    const fmt = (n) => {
        const num = Number(n ?? 0);
        return num.toLocaleString('en-IN', { maximumFractionDigits: 2 });
    };
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    return (





        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">Approvals</h6>
                    </div>
                    <div className="">
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>

                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={filteredRecords}
                            columns={columns}
                            getRowId={(r) => r.student_id}
                            showToolbar={false}
                            pagination
                            pageSizeOptions={[10, 20, 50]}
                            density="compact"
                            maxHeight={550}
                        />
                    )}
                </div>
            </div>
            <Modal
                show={showExitForm}
                onHide={() => setShowExitForm(false)}
                centered
                size="xl"

                dialogClassName="fixed-modal"


            >

                <Modal.Header closeButton>
                    <Modal.Title>Student Exit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className="px-2 py-1">
                        <Row className="mb-3">
                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Student Name:</strong>
                                <span>{form.student_last_name} {form.student_first_name}</span>
                            </Col>
                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "190px" }}>Admission Number:</strong>
                                <span>{form.admission_number}</span>
                            </Col>

                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Class:</strong>
                                <span>{form.class_name}</span>
                            </Col>
                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "190px" }}>Section:</strong>
                                <span>{form.section_name}</span>
                            </Col>

                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Father :</strong>
                                <span>{form.father_surname} {form.father_firstname}</span>
                            </Col>
                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "190px" }}>Mother :</strong>
                                <span>{form.mother_surname} {form.mother_firstname}</span>
                            </Col>

                        </Row>

                        {studentFeeSchedule.length > 0 && (
                            <div style={{ marginTop: "5px" }}>

                                {/* Summary above the table */}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: 16,
                                        justifyContent: "space-between",

                                        background: "#f8f9fa",
                                        borderRadius: 6,
                                        marginBottom: 8,
                                        fontWeight: 600
                                    }}
                                >
                                    <div>Total Fee: {fmt(feeDetail?.total_fee)}</div>
                                    <div>Paid: {fmt(feeDetail?.total_paid)}</div>
                                    <div>Balance: {fmt(feeDetail?.balance)}</div>
                                </div>

                                <table className="receipt-table">
                                    <thead>
                                        <tr>
                                            <th>Schedule Name</th>
                                            <th style={{ textAlign: 'right' }}>Scheduled Amount</th>
                                            <th style={{ textAlign: 'right' }}>Amount Paid</th>
                                            <th style={{ textAlign: 'right' }}>Balance</th>
                                            <th style={{ textAlign: 'center' }}>Due Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {studentFeeSchedule.map((item, index) => {
                                            const isOverdue =
                                                Number(item.balance_amount_to_be_paid) > 0 &&
                                                new Date(item.due_date?.split("/").reverse().join("-")) < new Date();

                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            <span style={{ paddingLeft: 10 }}>{item.schedule_name}</span>
                                                            {Number(item.balance_amount_to_be_paid) === 0 && (
                                                                <BsPatchCheckFill color="#28a745" size={18} title="Paid" />
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{fmt(item.scheduled_amount)}</td>
                                                    <td style={{ textAlign: 'right' }}>{fmt(item.amount_paid)}</td>
                                                    <td
                                                        style={{
                                                            textAlign: 'right',
                                                            color: isOverdue ? 'red' : 'inherit',
                                                            fontWeight: isOverdue ? 600 : 'normal',
                                                        }}
                                                    >
                                                        {fmt(item.balance_amount_to_be_paid)}
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>{item.due_date}</td>
                                                </tr>
                                            );
                                        })}

                                        {/* Optional footer totals */}
                                        {/* <tr style={{ fontWeight: 600, background: "#f8f9fa" }}>
                                 <td style={{ textAlign: 'right' }}>Totals:</td>
                                 <td style={{ textAlign: 'right' }}>{fmt(feeDetail?.total_fee)}</td>
                                 <td style={{ textAlign: 'right' }}>{fmt(feeDetail?.total_paid)}</td>
                                 <td style={{ textAlign: 'right' }}>{fmt(feeDetail?.balance)}</td>
                                 <td></td>
                               </tr> */}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        <Row className="mb-3">
                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Exit Type:</strong>
                                <span>{form.exit_type}</span>
                            </Col>

                            <Col md={6} className="mb-2 d-flex align-items-start">
                                <strong style={{ width: "160px" }}>Document:</strong>
                                <div style={{ wordBreak: "break-word", maxWidth: "calc(100% - 160px)" }}>
                                    {form.document &&
                                        form.document.split(',').map((file, index) => (
                                            <div key={index}>
                                                <a
                                                    href={`${baseUrl}/uploads/get-image/${file.trim()}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    download
                                                    style={{ display: "inline-block", wordBreak: "break-word", color: "#0d6efd" }}
                                                >
                                                    {file.trim()}
                                                </a>
                                            </div>
                                        ))}
                                </div>
                            </Col>




                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Next School:</strong>
                                <span>{form.which_school_student_has_gone}</span>
                            </Col>

                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Comments:</strong>
                                <span>{form.exit_reason}</span>
                            </Col>



                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Date of Exit:</strong>
                                <span>{form.date_of_exit ? new Date(form.date_of_exit).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "numeric", // use "long" for full month name
                                    year: "numeric"
                                }) : ""}</span>
                            </Col>


                            <Col md={6} className="mb-2 d-flex align-items-center">
                                <strong style={{ width: "160px" }}>Principal Comments:</strong>
                                {form.exit_status === "Pending" ? (
                                    <Form.Control
                                        as="textarea"
                                        value={form.comments || ""}
                                        placeholder="Enter principal comments"
                                        onChange={(e) => setForm({ ...form, comments: e.target.value })}
                                        rows={2}
                                        maxLength={300}
                                        style={{ flex: 1 }}
                                    />
                                ) : (
                                    <Form.Control
                                        as="textarea"
                                        value={form.comments || ""}
                                        readOnly
                                        rows={2}
                                        style={{ flex: 1, backgroundColor: "#f8f9fa" }}
                                    />
                                )}
                            </Col>

                        </Row>

                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    {form.exit_status === "Pending" ? (
                        <>
                            <Button
                                variant="danger"
                                onClick={() => updateExitStatus("Rejected")}
                                disabled={isLoading}
                            >
                                Reject
                            </Button>

                            <Button
                                variant="success"
                                onClick={() => updateExitStatus("Approved")}
                                disabled={isLoading}
                            >
                                Approve
                            </Button>
                        </>
                    ) : (
                        <Button variant="secondary" onClick={() => setShowExitForm(false)}>
                            Cancel
                        </Button>
                    )}
                </Modal.Footer>

            </Modal>
        </div>




    );
};

export default Approvals;
